import State from '../core/State';

export const setLocationCode = (locationCode: string) => (state: State): State => ({
  ...state,
  locationCode,
});
